var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ivu-global-footer i-copyright" }, [
    _c("div", { staticClass: "footers acea-row" }, [
      _c("div", { staticClass: "flex-center" }, [
        _c("div", {
          staticClass: "title",
          domProps: { textContent: _vm._s(_vm.copyrightNew) },
        }),
        _c(
          "a",
          {
            staticClass: "mt8",
            attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" },
          },
          [_vm._v("琼ICP备2026002332号-2")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }